<template>
  <div id="main">
    <div class="left">
      <fund />
      <trans />
      <todo :todo-list="todoList" />
    </div>
    <div class="right">
      <fx />
      <calendar :holiday-notify="holidayNotify" />
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import Fund from './components/fund'
import Todo from './components/todo'
import Trans from './components/trans'
import Fx from './components/fx'
import Calendar from './components/calendar'
import { useStore } from 'vuex'
import { _home, _user } from '@/api'
import i18n from '@/locale'

export default defineComponent({
  name: 'MainPage',
  components: {
    'fund': Fund,
    'todo': Todo,
    'trans': Trans,
    'fx': Fx,
    'calendar': Calendar
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const state = reactive({
      todoList: [],
      holidayNotify: ''
    })

    const init = async () => {
      loadTodoList()
    }

    const loadTodoList = async () => {
      console.log('loadTodoList')
      const userInfo = store.getters.getUserInfo
      let language = localStorage.getItem('locale-language')
      if (!language) language = (navigator.language || navigator.browserLanguage).toLowerCase().substr(0, 2)
      // product and holiday notify process
      const notifyRes = await _home.getNoticeInfo({ merchantNo: userInfo.merchantNo })
      if (notifyRes.data.succ) {
        console.log('notifyRes.data.data', notifyRes.data.data)
        const { noCheckedProList, smsTextCn, smsTextEn } = notifyRes.data.data
        // test data
        // const noCheckedProList = [
        //   { id: 1, checkStatus: '00', createTime: new Date().toLocaleString() },
        //   { id: 2, checkStatus: '03', createTime: new Date().toLocaleString() },
        //   { id: 4, checkStatus: '00', createTime: new Date().toLocaleString() },
        //   { id: 4, checkStatus: '03', createTime: new Date().toLocaleString() }
        // ]
        // const smsTextCn = '测试'
        // const smsTextEn = 'Test'

        if (language === 'zh') {
          noCheckedProList.map(item => {
            if (item.id === 4) {
              if (item.checkStatus === '00') {
                state.todoList.push({ title: '国际汇款产品校验提醒', content: '请先提交国际汇款交易支持材料，以免影响国际汇款交易。', time: item.createTime, notifyType: 1 })
              } else if (item.checkStatus === '03') {
                state.todoList.push({ title: '国际汇款产品校验提醒', content: '您提交的支持材料审核未通过，请重新提交，以免影响国际汇款交易。', time: item.createTime, notifyType: 1 })
              }
            }
          })
          if (smsTextCn) {
            state.holidayNotify = smsTextCn
          }
        } else {
          noCheckedProList.map(item => {
            if (item.id === 4) {
              if (item.checkStatus === '00') {
                state.todoList.push({ title: 'International Remittance Product Verification Reminder', content: 'Please submit the international remittance support materials first to avoid affecting the transaction.', time: item.createTime, notifyType: 1 })
              } else if (item.checkStatus === '03') {
                state.todoList.push({ title: 'International Remittance Product Verification Reminder', content: 'The support materials you submitted did not pass the review, please resubmit them to avoid affecting the transaction.', time: item.createTime, notifyType: 1 })
              }
            }
          })
          if (smsTextEn) {
            state.holidayNotify = smsTextEn
          }
        }
      }

      // expire notify process
      const expireRes = await _user.queryCertificateExpired()
      if (expireRes.data.succ) {
        console.log('expireRes.data.data', expireRes.data.data)
        let updateCert = false
        for (const i in expireRes.data.data) {
          if (expireRes.data.data[i]) {
            updateCert = true
            break
          }
        }
        // test
        // updateCert = true
        if (updateCert) {
          state.todoList.push({ title: i18n.global.t('pages_home_todo_003'), content: i18n.global.t('pages_home_todo_004'), time: new Date().toLocaleString(), notifyType: 2 })
        }
      }
      console.log('state.todoList', state.todoList)
    }

    init()

    const checkUsernameAndRedirect = async () => {
      try {
        const userInfo = store.getters.getUserInfo
        // regular express check M+10Digits
        const reg = /^M\d{10}$/
        if (reg.test(userInfo.name)) {
          router.push('/wallet/index')
        }
      } catch (error) {
        console.error('Failed to get user info:', error)
      }
    }

    onMounted(() => {
      checkUsernameAndRedirect()
    })

    return {
      ...toRefs(state)
    }
  }
})
</script>

<style lang="less">
#main {
  display: flex;
  // justify-content: center;
  // align-items: center;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  // left/right 2 areas
  flex-direction: row;
  padding: 0 20px;
  // left 80% right 20%
  align-items: flex-start;
  justify-content: flex-start;
  .left {
    width: 70%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 15px;
    margin-right: 20px;
    ;
  }
  .right {
    width: 30%;
    height: 100%;
    display: flex;
    padding: 15px;
    flex-direction: column;
  }
  .widget {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
    padding-bottom: 20px;;
    .title {
      font-size: 20px;
      font-weight: 500;
      color: #000;
      align-items: flex-start;
    }
    .title-sub {
      font-size: 18px;
      font-weight: 500;
      color: rgb(60, 58, 58);
    }
    .content {
      font-size: 14px;
      font-weight: 500;
      color: rgb(60, 58, 58);
    }
  }
}

@media (max-width: 768px) {
}

@media (max-width: 480px) {
  #main {
    flex-direction: column;
    .left {
      width: 100% !important;
      margin-right: 0  !important;
    }
    .right {
      width: 100% !important;
    }
  }
}
</style>
